<template>
  <v-container>
    <v-row>
      <v-col>
        <h1 class="title text-center mb-6">嵩豐建設線上維修系統登錄</h1>
        <v-text-field label="Email" v-model="email" required></v-text-field>
        <v-text-field
          label="密碼"
          :type="'password'"
          v-model="password"
          required
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="d-flex justify-center">
        <v-btn depressed @click="login" color="blue-grey white--text"
          >登入</v-btn
        >
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// @ is an alias to /src
import firebase from "firebase";

export default {
  name: "Login",
  data: () => ({
    valid: true,
    email: "",
    password: ""
  }),
  methods: {
    login() {
      firebase
        .auth()
        .signInWithEmailAndPassword(this.email, this.password)
        .then(
          data => {
            alert(`${data.user.email} 成功登陸`);
            // this.$router.go("/dashboard");
            this.$router.replace({ name: "Dashboard" });
          },
          err => {
            alert(err.message);
          }
        );
    }
  }
};
</script>
